<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-form">
      <!--begin::Form-->
      <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon-home"></i>
            </span>
            <h3 class="kt-portlet__head-title">{{this.$route.meta.breadcrumb}}</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <div class="kt-section kt-section--first">
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label class="label-required">ประเภทผู้ติดต่อ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control'"
                    :id="'couContactType'"
                    :name="'couContactType'"
                    :select2-options="couContactTypeOptions"
                    v-model="couContactType"
                    ref="couContactTypeSelect2"
                  ></select2>
                  <span class="form-text"></span>
                </div>
              </div>

              <div class="col-xl-12">
                <div class="form-group">
                  <label class="label-required" v-show="couContactType!='other'">บริษัท:</label>
                  <label v-show="couContactType=='other'">บริษัท:</label>
                  <div v-show="couContactType=='agent'">
                    <select2
                      :css-style="'width: 100%;'"
                      :class="'form-control'"
                      :id="'couAgentId'"
                      :name="'couAgentId'"
                      :select2-options="couAgentOptions"
                      v-model="couAgentId"
                      ref="couAgentIdSelect2"
                    ></select2>
                    <span class="form-text"></span>
                  </div>
                  <div v-show="couContactType=='vendor'">
                    <select2
                      :css-style="'width: 100%;'"
                      :class="'form-control'"
                      :id="'couVendorId'"
                      :name="'couVendorId'"
                      :select2-options="couVendorOptions"
                      v-model="couVendorId"
                      ref="couVendorIdSelect2"
                    ></select2>
                    <span class="form-text"></span>
                  </div>
                  <div v-show="couContactType=='plant'">
                    <select2
                      :css-style="'width: 100%;'"
                      :class="'form-control'"
                      :id="'couPlantId'"
                      :name="'couPlantId'"
                      :select2-options="couPlantOptions"
                      v-model="couPlantId"
                      ref="couPlantIdSelect2"
                    ></select2>
                    <span class="form-text"></span>
                  </div>
                  <div v-show="couContactType=='other'">
                    <input
                      id="couOtherId"
                      name="couOtherId"
                      v-model="couOtherId"
                      type="text"
                      maxlength="450"
                      class="form-control"
                      placeholder="ชื่อบริษัท"
                    />
                  </div>
                  <div v-show="!couContactType">
                    <select2
                      :css-style="'width: 100%;'"
                      :css-class="'form-control'"
                      :id="'couCompanyId'"
                      :name="'couCompanyId'"
                      :select2-options="couCompanyIdOptions"
                      v-model="couCompanyId"
                      ref="couCompanyIdSelect2"
                    ></select2>
                    <span class="form-text"></span>
                  </div>
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label class="label-required">ชื่อ:</label>
                  <input
                    id="couContactName"
                    name="couContactName"
                    v-model="couContactName"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="ชื่อผู้ติดต่อ"
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label class="label-required">นามสกุล:</label>
                  <input
                    id="couContactLastName"
                    name="couContactLastName"
                    v-model="couContactLastName"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="นามสกุล"
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label class="label-required">ตำแหน่ง:</label>
                  <input
                    id="couContactPositions"
                    name="couContactPositions"
                    v-model="couContactPositions"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="ตำแหน่ง"
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label>ชื่อเล่น:</label>
                  <input
                    id="couContactNickName"
                    name="couContactNickName"
                    v-model="couContactNickName"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="ชื่อเล่น"
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label class="label-required">เบอร์ติดต่อ:</label>
                  <input
                    id="couContactTel"
                    name="couContactTel"
                    v-model="couContactTel"
                    type="text"
                    maxlength="450"
                    class="form-control"
                    placeholder="เบอร์ติดต่อ"
                  />
                </div>
              </div>

              <div class="col-xl-6 col-lg-6 col-md-6 .col-sm-6 col-xs-6">
                <div class="form-group">
                  <label class="label-required">E-mail:</label>
                  <input
                    id="couContactEmail"
                    name="couContactEmail"
                    v-model="couContactEmail"
                    type="email"
                    maxlength="450"
                    class="form-control"
                    placeholder="E-mail"
                  />
                </div>
              </div>
              <div class="col-xl-12">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        name="couInActiveStatus"
                        id="couInActiveStatus"
                        v-model="couInActiveStatus"
                      />
                      <span></span>
                      เปิดใช้งาน
                    </label>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="kt-portlet__foot">
          <button type="button" class="btn btn-secondary" @click="$router.go(-1)">
            <i class="la la-close"></i> ย้อนกลับ
          </button>
          <button type="submit" class="btn btn-primary">
            <i class="la la-save"></i> บันทึกข้อมูล
          </button>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../../Shared/Select2";

export default {
  components: {
    select2
  },
  data: function() {
    var self = this;

    return {
      couContactName: null,
      couContactLastName: null,
      couContactPositions: null,
      couContactNickName: null,
      couContactTel: null,
      couContactEmail: null,
      couCompanyId: null,
      couAgentId: null,
      couVendorId: null,
      couPlantId: null,
      couOtherId: null,
      couContactType: null,
      couInActiveStatus: true,
      couContactTypeOptions: {
        placeholder: "กรุณาเลือก",
        data: [
          { id: "agent", text: "Agent", data: null },
          { id: "vendor", text: "Supplier", data: null },
          { id: "plant", text: "คลังสินค้า", data: null },
          { id: "other", text: "อื่นๆ", data: null }
        ]
      },
      couCompanyIdOptions: {
        placeholder: "กรุณาเลือก",
        data: [{ id: "", text: "", data: null }]
      },
      couAgentOptions: {
                placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Agents/Select2SearchAgentName",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              department: [],
              province_id: [],
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }

      },
      couVendorOptions:{
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Vendors/Select2Vendor",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      },
      couPlantOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Plant/Select2Plant",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more
              }
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          }
        }
      }
    };
  },
  methods: {
    formSubmit: function(e) {
      e.preventDefault();

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่..."
      });

      let router = this.$router;
      let self = this;

      var tmp = "";
      if (this.couContactType == "agent") {
        tmp = this.couAgentId;
      } else if (this.couContactType == "vendor") {
        tmp = this.couVendorId;
      }else if (this.couContactType == "plant") {
        tmp = this.couPlantId;
      }else if (this.couContactType == "other") {
        tmp = this.couOtherId;
      }

      axios
        .put("/Api/TransitContactor", {
          TransitContactorId: this.$route.params.id,
          ContactName: this.couContactName,
          ContactLastName: this.couContactLastName,
          ContactPositions: this.couContactPositions,
          ContactNickName: this.couContactNickName,
          ContactTel: this.couContactTel,
          ContactEmail: this.couContactEmail,
          CompanyType: this.couContactType,
          CompanyID: tmp,
          InActiveStatus: !this.couInActiveStatus
        })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                router.go(-1), self.$parent.reloadDataTable(false);
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    }
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    axios
      .get("/Api/TransitContactor/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          self.couContactName = response.data.contactName;
          self.couContactLastName = response.data.contactLastName;
          self.couContactPositions = response.data.position;
          self.couContactNickName = response.data.nickName;
          self.couContactTel = response.data.tel;
          self.couContactEmail = response.data.email;
          self.couInActiveStatus = !response.data.inActiveStatus;
          if (response.data.companyType) {
            $(self.$refs.couContactTypeSelect2.$el)
              .val(response.data.companyType)
              .trigger("change");
          }

          if (response.data.companyId && response.data.companyType == "agent") {
            self.$refs.couAgentIdSelect2.setSelectedData({
              id: response.data.companyId,
              text:
                "[" + response.data.companyId + "] " + response.data.companyName
            });
          }

          if (response.data.companyId && response.data.companyType == "vendor") {
            self.$refs.couVendorIdSelect2.setSelectedData({
              id: response.data.companyId,
              text:
                "[" + response.data.vendorNo + "] " + response.data.companyName
            });
          }

          if (response.data.companyId && response.data.companyType == "plant") {
            self.$refs.couPlantIdSelect2.setSelectedData({
              id: response.data.companyId,
              text:
                response.data.companyName + " (" + response.data.plantDesc2 + ")"
            });
          }

          if (response.data.companyId && response.data.companyType == "other") {
            self.couOtherId = response.data.companyId;
          }

        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูลขนส่งคุณเลือก", "warning");
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลขนส่งได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });

      $(this.$refs.form).validate({
      rules: {
        couContactType: "required",
        couCompanyId: "required",
        couAgentId: "required",
        couVendorId: "required",
        couPlantId: "required",
        couContactName: "required",
        couContactLastName: "required",
        couContactPositions: "required",
        couContactTel: "required",
        couContactEmail: {
          required: true,
          email: true
        },

      },
      messages: {
        couContactType: "กรุณาเลือกประเภทผู้ติดต่อ",
        couCompanyId: "กรุณาเลือกบริษัท",
        couAgentId: "กรุณาเลือกบริษัท",
        couVendorId: "กรุณาเลือกบริษัท",
        couPlantId: "กรุณาเลือกบริษัท",
        couContactName: "กรุณากรอกชื่อ",
        couContactLastName: "กรุณากรอกนามสกุล",
        couContactPositions: "กรุณากรอกตำแหน่ง",
        couContactTel: "กรุณากรอกเบอร์ติดต่อ",
        couContactEmail: {
          required : "กรุณากรอกอีเมล",
          email: "กรุณากรอกอีเมลให้ถูกต้อง"
        },
       
      }
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";

   
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// App/Components/Master/Contact/ContactUpdate.vue